// Helpers
import { wheelSetClass } from "helpers/class";

// Types
import { WheelType } from "types/Wheel";

import "./styles.sass";

type FrameGirlProps = {
  idle: boolean;
  type: WheelType;
};

const WheelFrame = (props: FrameGirlProps) => {
  const { idle, type } = props;
  return (
    <>
      <div className={wheelSetClass("WheelFrame", type)}>
        <div
          className={wheelSetClass("WheelFrame-lights", type, "first", idle)}
        />
        <div
          className={wheelSetClass("WheelFrame-lights", type, "second", idle)}
        />
      </div>
      <div className={wheelSetClass("WheelFrame-bg", type, "first")} />
      <div className={wheelSetClass("WheelFrame-bg", type, "second")} />
    </>
  );
};
export default WheelFrame;
